import { withInstall } from "../utils/index.mjs";
import _DropdownItem from "./DropdownItem.mjs";
const DropdownItem = withInstall(_DropdownItem);
var stdin_default = DropdownItem;
export {
  DropdownItem,
  stdin_default as default
};
